import { IsTileMapLayer } from "core/tiles";
export function IsElevationLayerOptions(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.exageration !== undefined || b.offsets !== undefined;
}
export function IsElevationLayer(b) {
    return IsTileMapLayer(b) && IsElevationLayerOptions(b);
}
//# sourceMappingURL=dem.interfaces.js.map